"use client";

import { useContext } from "react";

import { NonceContext } from "./nonce-context.js";

export const useNonce = () => {
  const nonce = useContext(NonceContext);

  if (nonce === null) {
    throw new Error("useNonce must be used within NonceProvider");
  }

  return nonce;
};
